// symbols.ts
var loaderSymbol = Symbol("adornis-loader-controller");
export {
  loaderSymbol
};
